import React from 'react';
import { Tabs, TabsList, TabsTrigger, TabsContent } from '../components/ui/tabs';
import { Card, CardContent } from '../components/ui/card';
import { Globe, Store, Info } from 'lucide-react';
import MallConfig from './MallConfig';
import StoreConfig from './StoreConfig';

// Módulo unificado: Vitrina (catálogo público general) + Tienda Web (configuración por sucursal).
// Antes eran dos botones separados ("Vitrina Web" y "Tienda Web") que confundían y cruzaban
// información entre empresas. Ahora es un solo espacio, aislado por empresa.
export default function WebPresence() {
  return (
    <div className="space-y-5" data-testid="web-presence-page">
      <div>
        <h1 className="font-heading font-bold text-2xl text-[#022C22] flex items-center gap-2">
          <Globe size={22} /> Vitrina / Tienda Web
        </h1>
        <p className="text-sm text-[#64748B]">Tu presencia en línea, en un solo lugar.</p>
      </div>

      <Card className="border-[#CFF8E7] bg-[#F0FDF9]" data-testid="web-presence-explainer">
        <CardContent className="p-4 text-sm text-[#065F46] space-y-2">
          <p className="flex items-center gap-2 font-semibold"><Info size={15} /> ¿Cómo funciona y por qué se unió?</p>
          <ul className="list-disc pl-5 space-y-1 text-[13px] leading-relaxed">
            <li><b>Vitrina (catálogo público general):</b> la vista de marca, tasas (USD/Bs), datos de pago e información que comparten todas tus sucursales. Es lo que ve el público en tu dominio.</li>
            <li><b>Tienda por sucursal:</b> la configuración individual de CADA sucursal (categorías visibles, banners, identificador/slug y si está activa). Cada sucursal es independiente.</li>
            <li>Se fusionó en un solo módulo porque antes los dos botones (“Vitrina Web” y “Tienda Web”) hacían cosas parecidas y causaban confusión. Ahora todo tu escaparate en línea vive aquí, aislado por empresa: nunca verás ni editarás la vitrina de otra empresa.</li>
          </ul>
        </CardContent>
      </Card>

      <Tabs defaultValue="vitrina" className="w-full">
        <TabsList data-testid="web-presence-tabs">
          <TabsTrigger value="vitrina" data-testid="tab-vitrina"><Globe size={14} className="mr-1" /> Vitrina (general)</TabsTrigger>
          <TabsTrigger value="tienda" data-testid="tab-tienda"><Store size={14} className="mr-1" /> Tienda por sucursal</TabsTrigger>
        </TabsList>
        <TabsContent value="vitrina" className="mt-4"><MallConfig /></TabsContent>
        <TabsContent value="tienda" className="mt-4"><StoreConfig /></TabsContent>
      </Tabs>
    </div>
  );
}
